export class Raport {
    Id:Number;
    ParentId:Number;
    Name:string;

   }